// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.MarkPaymentAsPaidOfflineWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { MarkPaymentAsPaidOfflineWebApiRequestDto } from '../..';

export const MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Path =
  '/api/web/v1/landlord/markPaymentAsPaidOffline';

/**
 * Mark a recurring rent payment as received offline, on behalf of the landlord
 */
export const MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline = (
  postData: MarkPaymentAsPaidOfflineWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MarkPaymentAsPaidOfflineWebApiRequestDto, void>(
    {
      endpoint: MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
